var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaveAComment = function SvgLeaveAComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.979 4.2c0-2.31-1.869-4.2-4.179-4.2H4.2C1.89 0 0 1.89 0 4.2v25.2c0 2.31 1.89 4.2 4.2 4.2h29.4L42 42l-.021-37.8Zm-4.179 0v27.657L35.343 29.4H4.2V4.2h33.6ZM8.4 21h25.2v4.2H8.4V21Zm0-6.3h25.2v4.2H8.4v-4.2Zm0-6.3h25.2v4.2H8.4V8.4Z",
    fill: "#000"
  })));
};
export default SvgLeaveAComment;